import { render, staticRenderFns } from "./ExceptionTable.vue?vue&type=template&id=632bba10&scoped=true"
import script from "./ExceptionTable.vue?vue&type=script&lang=js"
export * from "./ExceptionTable.vue?vue&type=script&lang=js"
import style0 from "./ExceptionTable.vue?vue&type=style&index=0&id=632bba10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632bba10",
  null
  
)

export default component.exports